<template>
    <div>
        <div v-if="type_save">
            <b-form inline>
				<b-form-input placeholder="configuration" v-model="name"></b-form-input>
				<b-button v-b-modal="'modal' + id">Charger</b-button>
				<b-button @click="save_library" :disabled="!version || !name"><i class="fas fa-save"></i></b-button>
			</b-form>

			<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
				<span>Nom</span>
				<v-select v-model="load_name" :options="names"></v-select>
			</b-modal>
        </div>

        <div v-for="(param, idx) in params" :key="param.name">
            <span v-show="param.type.type != 'hidden' && param.type.type != 'booleen'" v-b-tooltip.hover :title="param.description">{{param.libelle || param.name}}</span><b-button v-if="!param.required && param.type.type != 'booleen'" variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
            <div v-if="param.type.type == 'texte'">
                <b-input :list="param.name" v-model="param.value" :type="param.type.html_type || 'text'"></b-input>
                <datalist v-if="param.type.datalist && param.type.datalist.length > 0" :id="param.name">
                    <option v-for="(option, idx) in param.type.datalist" :key="idx">{{ option }}</option>
                </datalist>
            </div>
            <div v-if="param.type.type == 'draggable'">
                <draggable
                    group="step"
                    :list="param.value"
                    class="list-group">
                    <div class="list-group-item" v-for="(obj, idx_list) in param.value" :key="idx_list" style="background: none;">
                        <b-input-group :prepend="'' + (idx_list + 1)">
                            <b-input :list="param.name + idx" v-model="obj.value" :type="'text'"></b-input>
                            <b-button @click="del_elem(idx, idx_list)" variant="danger"><i class="fas fa-trash"></i></b-button>
                        </b-input-group>
                        <datalist :id="param.name + idx">
                            <option v-for="(option, idx) in (param.type.data_columns ? columns_data : param.type.datalist)" :key="idx">{{ option }}</option>
                        </datalist>
                    </div>
                </draggable>
    			<b-button @click="new_elem(idx)"><i class="fas fa-plus"></i></b-button>
                <br />
            </div>
            <div v-if="param.type.type == 'draggable_list'">
                <draggable
                    group="step"
                    :list="param.value"
                    class="list-group">
                    <div class="list-group-item" v-for="(obj, idx_list) in param.value" :key="idx_list" style="background: none;">
                        <b-input-group :prepend="'' + (idx_list + 1)">
                            <b-form-select v-model="obj.value" :options="param.type.options"></b-form-select>
                            <b-button @click="del_elem(idx, idx_list)" variant="danger"><i class="fas fa-trash"></i></b-button>
                        </b-input-group>
                    </div>
                </draggable>
    			<b-button @click="new_elem(idx)"><i class="fas fa-plus"></i></b-button>
                <br />
            </div>
            <div v-if="param.type.type == 'textarea'">
                <b-textarea :rows="param.type.rows || 5" v-model="param.value"></b-textarea>
            </div>
            <div v-if="param.type.type == 'textarea_plus'">
                <textarea_plus :ref="'params_' + idx" :columns="columns_data.length > 0 ? columns_data : columns"></textarea_plus>
            </div>
            <div v-if="param.type.type == 'json_schema_editor'">
                <json_schema_editor :ref="'params_' + idx" :columns="columns_data.length > 0 ? columns_data : columns"></json_schema_editor>
            </div>
            <div v-if="param.type.type == 'null'">
                Valeur vide
            </div>
            <div v-if="param.type.type == 'booleen'" class="d-flex align-items-center" style="gap:6px">
                <b-form-checkbox v-model="param.value" :value="true" :unchecked-value="false" v-b-tooltip.hover :title="param.description">{{ param.libelle || param.name }}</b-form-checkbox>
                <b-button v-if="!param.required" variant="link" class="p-0" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
            </div>
            <div v-if="param.type.type == 'checkbox'">
                <b-form-checkbox-group
                    :name="param.name"
                    v-model="param.value"
                    :options="param.type.options"
                ></b-form-checkbox-group>
            </div>
            <div v-if="param.type.type == 'radio'">
                <b-form-radio inline v-for="(option, idx) in param.type.options" :key="idx" v-model="param.value" :name="param.name" :value="option.value">{{ option.text }}</b-form-radio>
            </div>
            <div v-if="param.type.type == 'list'">
                <b-form-select v-model="param.value" :options="param.type.options" :multiple="param.type.multiple"></b-form-select>
            </div>
            <div v-if="param.type.type == 'autocomplete'">
                <vue-tags-input v-if="param.value"
                    :autocomplete-min-length="0"
                    placeholder="Ajouter"
                    v-model="val"
                    :tags="param.value"
                    :autocomplete-items="filteredItems(idx)"
                    @tags-changed="newOptions => param.value = newOptions"
                    style="max-width: 100%;" />
            </div>
            <div v-if="param.type.type == 'autocomplete_list'">
                <list_param :columns_data="columns_data" :is_data_columns="param.type.data_columns" :ref="'params_' + idx" ></list_param>
            </div>
            <div v-if="param.type.type == 'database'">
                <b-form-select
                    v-model="param.type.table"
                    :options="tables"
                    v-on:input="updateTable(idx)" />
                <br /><br />
                <database
                    :name="false"
                    :edit="false"
                    :ref="'params_' + idx"></database>
            </div>
            <div v-if="param.type.type == 'documents'">
                <documents
                    :select="true"
                    :download="false"
                    :ref="'params_' + idx"></documents>
            </div>
            <div v-if="param.type.type == 'csv'">
                <edit_tabulator
                    :ref="'params_' + idx"></edit_tabulator>
            </div>
            <div v-if="param.type.type == 'docx'">
                <b-button @click="refresh(idx)"><i class="fas fa-sync-alt"></i></b-button><br /><br />
                <docx
                    :ref="'params_' + idx"></docx>
            </div>
            <div v-if="param.type.type == 'pdf_zones'">
                <b-button @click="refresh(idx)"><i class="fas fa-sync-alt"></i></b-button><br /><br />
                <document_extraction_zones :ref="'params_' + idx" :type_doc="param.type.type_doc || ''"></document_extraction_zones>
            </div>
            <div v-if="param.type.type == 'file_names'">
                <file_names_parameter :ref="'params_' + idx" ></file_names_parameter>
            </div>
            <div v-if="param.type.type == 'html_zones'">
                <document_extraction_parameters :files="files" @button_start="button_start" @refresh="refresh(idx)" :ref="'params_' + idx"></document_extraction_parameters>
            </div>
            <div v-if="param.type.type == 'mapping'">
                <mapping :client="client" :data="data" :files="files" :ref="'params_' + idx" :treatment_params="true"></mapping>
            </div>
            <div v-if="param.type.type == 'object'">
                <obj_editor :ref="'params_' + idx" />
            </div>
           <div v-if="param.type.type == 'database multitables'">
                <DatabaseRequestView
                    _type="db"
                    :minimal="true"
                    :ref="'params_' + idx" />
            </div>
        </div>
        <div v-if="optional_params.length > 0">
            <br />
            <div>Paramètres supplémentaires</div>
            <b-button variant="link" @click="add(idx)" v-b-tooltip.hover :title="param.description" v-for="(param, idx) in optional_params" :key="param.name">{{param.libelle || param.name}}</b-button>
        </div>
    </div>
</template>

<script>
	import VueTagsInput from "@johmun/vue-tags-input";
    import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";

    import document_extraction_parameters from '../components/document_extraction_parameters.vue'
    import document_extraction_zones from '../components/document_extraction_zones.vue'
    import file_names_parameter from '../components/file_names_parameter.vue';
    import json_schema_editor from '../components/json_schema_editor.vue';
    import DatabaseRequestView from '../views/DatabaseRequestView.vue'
    import edit_tabulator from "../components/edit_tabulator.vue";
    import textarea_plus from '../components/textarea_plus.vue';
	import treatments from "../services/treatments.js";
    import databaseView from "../views/database.vue";
    import mapping from "../components/mapping.vue";
    import database from "../services/database.js";
	import documents from "../views/Document.vue";
    import library from "../services/library.js";
    import list_param from './list_param.vue';
    import obj_editor from './obj_editor.vue';
	import docx from "../components/docx.vue";
    import users from "../services/users.js";
    import store from "../store";
 
    var clone = require("clone");

	export default {
        name: "treatment_params",
        components: {
            obj_editor,
            list_param,
            textarea_plus,
            json_schema_editor,
            document_extraction_zones,
            document_extraction_parameters,
            VueTagsInput,
			database: databaseView,
            documents,
            draggable,
            DatabaseRequestView,
            edit_tabulator,
            docx,
            file_names_parameter,
            mapping
        },
		data() {
			return {
                params: [],
                optional_params: [],
                val: "",
                tables: [],
                
                id: uniqueId(""),

                name: "",
                names: "",
                load_name: "",
                type: "",
                version: "1",
                columns_data: []
			};
        },		
        computed: {
        },
        watch: 
        {
            params: {
                deep: true,
                handler() {
                    const map = {};
                    for (const p of this.params) {
                        if (p.name !== undefined) map[p.name] = p.value;
                    }
                    this.$emit('values_change', map);
                }
            },
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data && this.data.length > 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            url_files: {
                deep: true,
                immediate: true,
                async handler()
                {
                    if (this.url_files.length > 0 && this.url_files[0].name.endsWith(".csv"))
                    {
                        console.log("url_files")
                        var file = await treatments.getFileAlyx(this.url_files[0].url, false, "blob");
                        console.log(file)
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(file);

                        reader.readAsText(file);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0 && this.files[0].name.endsWith(".csv") && this.files[0].nb_size < 10)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            },
			load_name: {
				async handler() {
                    console.log("load_name")
					if (this.load_name) 
						await this.load_library();
				},
			},
            type_save: {
                immediate: true,
                handler()
                {
                    if (this.type_save)
                    {
                        this.type = "params " + this.type_save;
                        this.set_name();
                    }
                }
            },
        },
        props: {
			data: {
				default: () => [],
            },
            columns: {
                default: () => []
            },
            files: {
                default: () => []
            },
            type_save: {
                default: ""
            },
            type_save_default: {
                default: ""
            },
            url_files: {
                default: () => []
            },
        },
        methods: {
			async set_name()
			{
				var names = await library.getby_production(this.type, null, false, false, false);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].name);
				}
			},
            async save_library()
			{
				var data = this.get_obj();

				await library.save(
					this.name,
					this.version,
					data,
					this.type,
					false,
					{},
					true 
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement effectué",
					type: "success"
				});
			},
			async load_library()
			{
				var data = await library.load(
					this.load_name,
					this.version,
					this.type
				);
                this.name = this.load_name;
                this.set_obj(data);
                this.$emit("configuration", this.load_name);
            },
            get_load_name()
            {
                return this.load_name;
            },
            button_start(state)
            {
                console.log("button_start - " + state)
                this.$emit("button_start", state);
            },
            set_document_ged(file)
            {
                for (var i = 0; i < this.params.length; i++)
                {
                    if (this.params[i].type.type == 'pdf_zones')
                    {
                        this.$refs["params_" + i][0].set_document_ged(file);
                    }
                }
            },
            new_elem(idx, array = false)
            {
                if (!array)
                    this.params[idx].value.push({value: ""});
                else
                    this.params[idx].value.push({value: []});
            },
            del_elem(idx, idx_elem)
            {
                this.params[idx].value.splice(idx_elem, 1);
            },
            refresh(idx)
            {
                //console.log("refresh");
                this.$emit("get_initial_files", idx);
            },
            set_initial_files(idx, files)
            {
                //console.log("set_initial_files " + idx)
                this.$refs["params_" + idx][0].setDocument(files[0]);
            },
            filteredItems(idx) {
                return this.params[idx].type.options.filter(i => {
                    return i.text.toLowerCase().indexOf(this.val.toLowerCase()) !== -1;
                });
            },
            get()
            {
                var params = clone(this.params);

                for (var i = 0; i < params.length; i++)
                {
                    if (params[i].type.type == 'autocomplete')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push(params[i].value[j].text)
                        }
                        params[i].value = value
                    }
                    if (params[i].type.type == 'draggable' || params[i].type.type == 'draggable_list')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push(params[i].value[j].value)
                        }
                        params[i].value = value
                    }
                    if (params[i].type.type == 'database' || 
                        params[i].type.type == 'database multitables' || 
                        params[i].type.type == 'documents' || 
                        params[i].type.type == 'pdf_zones' || 
                        params[i].type.type == 'html_zones' || 
                        params[i].type.type == 'mapping' || 
                        params[i].type.type == 'csv' || 
                        params[i].type.type == 'docx' || 
                        params[i].type.type == 'textarea_plus' || 
                        params[i].type.type == 'json_schema_editor' || 
                        params[i].type.type == 'file_names' ||
                        params[i].type.type == 'autocomplete_list' ||
                        params[i].type.type == 'object')
                    {
                        params[i].value = this.$refs["params_" + i][0].get_data();
                    }
                    if (params[i].type.datalist_values && params[i].type.datalist_values[params[i].value])
                        params[i].value = params[i].type.datalist_values[params[i].value];

                    if (params[i].type.datalist_values)
                        delete params[i].type.datalist_values;
                    if (params[i].type.datalist)
                        delete params[i].type.datalist;
                    if (params[i].type.options)
                        delete params[i].type.options;
                }

                // Paramètres scénario (v2) optionnels non cochés : pas d'éditeur actif dans
                // ce formulaire, mais leur valeur (défaut, ou mise à jour par un script lors
                // d'un test précédent) doit quand même être transmise au worker — les scripts
                // personnalisés accèdent à TOUS les paramètres du scénario via `treatment_params`,
                // indépendamment de leur état "coché" ici (cf. doc "Scripts personnalisés").
                // Les paramètres v1 (legacy, sans `targets`) gardent l'ancien comportement :
                // non envoyés tant qu'ils ne sont pas explicitement ajoutés par l'utilisateur.
                var optional = clone(this.optional_params).filter(p => Array.isArray(p.targets));
                for (var i = 0; i < optional.length; i++)
                {
                    if (optional[i].type && optional[i].type.datalist_values)
                        delete optional[i].type.datalist_values;
                    if (optional[i].type && optional[i].type.datalist)
                        delete optional[i].type.datalist;
                    if (optional[i].type && optional[i].type.options)
                        delete optional[i].type.options;
                }
                params = params.concat(optional);

                console.log('[treatment_params.get()] résultat:', params.map(p => ({name: p.name, value: p.value})));
                return params;
            },
            get_obj()
            {
                var params = this.get();
                var obj = {};
                
                for (var i = 0; i < params.length; i++)
                {
                    obj[params[i].name] = params[i].value;
                }

                return obj;
            },
            async set_obj(data)
            {
                var self = this;

                for (var i = 0; i < this.params.length; i++)
                {
                    if (data.hasOwnProperty(this.params[i].name));
                    {
                        this.params[i].value = data[this.params[i].name] || this.params[i].default;
                        if (this.params[i].type.type == 'autocomplete')
                        {
                            var value = [];
                            for (var j = 0; j < this.params[i].value.length; j++)
                            {
                                value.push({"text": this.params[i].value[j]})
                            }
                            this.params[i].value = value;
                        }
                        if (this.params[i].type.type == 'draggable' || this.params[i].type.type == 'draggable_list')
                        {
                            var value = [];
                            for (var j = 0; j < this.params[i].value.length; j++)
                            {
                                this.value.push({"value": this.params[i].value[j]})
                            }
                            this.params[i].value = value;
                        }
                    }
                }
                for (var i = 0; i < this.optional_params.length; i++)
                {
                    if (data.hasOwnProperty(this.optional_params[i].name) && data[this.optional_params[i].name])
                    {
                        this.optional_params[i].value = data[this.optional_params[i].name];
                        await this.add(i);
                        i--;
                    }
                }

                await this.$nextTick();

                for (var i = 0; i < this.params.length; i++)
                {
                    if ((this.params[i].type.type == 'textarea_plus' || 
                    this.params[i].type.type == 'json_schema_editor' || 
                    this.params[i].type.type == 'autocomplete_list' || 
                        this.params[i].type.type == 'object') && this.$refs["params_" + i])
                        this.$refs["params_" + i][0].load(this.params[i].value);
                }
            },
            /**
             * Met à jour les valeurs des paramètres après l'exécution d'un script (mode test).
             * Met à jour uniquement `value` — ne touche pas `default` ni les autres métadonnées.
             * Accepte les formats v1 ({ name, value }) et v2 ({ name, value, targets }).
             * Si le paramètre est optionnel et pas encore coché (dans `optional_params`),
             * il est promu dans `params` (comme si l'utilisateur l'avait ajouté) sinon sa
             * valeur ne serait jamais affichée.
             * @param {Array} params - Tableau de params retournés par le worker (treatment_params)
             */
            update_values(params)
            {
                if (!params || !Array.isArray(params)) return;
                for (var i = 0; i < params.length; i++) {
                    var incoming = params[i];
                    if (!incoming.name) continue;
                    var value = incoming.value !== undefined ? incoming.value : incoming.default_value;
                    if (value === undefined) continue;
                    var found = false;
                    for (var j = 0; j < this.params.length; j++) {
                        if (this.params[j].name === incoming.name) {
                            this.$set(this.params[j], 'value', value);
                            found = true;
                            break;
                        }
                    }
                    if (found) continue;
                    for (var k = 0; k < this.optional_params.length; k++) {
                        if (this.optional_params[k].name === incoming.name) {
                            this.optional_params[k].value = value;
                            this.add(k);
                            break;
                        }
                    }
                }
            },
            async set(params)
            {
                if (this.is_set)
                    return;

                this.is_set = true;
                var self = this;

                params = clone(params)
                //console.log(params)
                this.params = [];
                this.optional_params = [];
                for (var i = 0; i < params.length; i++)
                {
                    // Format v2 (params scénario avec cibles) : la valeur par défaut est
                    // stockée dans `value`/`default_value`, pas dans `default` (cf. update_values).
                    if (Array.isArray(params[i].targets))
                        params[i].value = params[i].value !== undefined ? params[i].value : params[i].default_value;
                    else
                        params[i].value = params[i].default;
                    if (params[i].type.type == 'booleen')
                        params[i].value = (params[i].value === true || params[i].value === 'true' || params[i].value === 1 || params[i].value === '1');
                    if (params[i].type.type == 'autocomplete')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push({"text": params[i].value[j]})
                        }
                        params[i].value = value
                    }
                    if (params[i].type.type == 'draggable' || params[i].type.type == 'draggable_list')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push({"value": params[i].value[j]})
                        }
                        params[i].value = value;
                    }

                    if (params[i].type.db && params[i].type.db.table)
                    {
                        var params_db = {
                            select: params[i].type.db.value + " AS value, " + params[i].type.db.libelle + ' AS libelle',
                        };
                        if (params[i].type.db.where)
                            params_db.where = params[i].type.db.where;
                        if (params[i].type.db.end)
                            params_db.end = params[i].type.db.end;

                        var results = await database.get("SELECT", params[i].type.db.table, params_db);

                        if (params[i].type.type == "list")
                        {
                            for (var j = 0; j < results.length; j++)
                            {
                                params[i].type.options.push({value: results[j].value, text: results[j].libelle})
                            }
                        }
                        else
                        {
                            params[i].type.datalist_values = {}
                            for (var j = 0; j < results.length; j++)
                            {
                                params[i].type.datalist.push(results[j].libelle);
                                params[i].type.datalist_values[results[j].libelle] = results[j].value;
                            }
                        }
                    }
                    if (params[i].required)
                    {
                        this.params.push(params[i]);
                    }
                    else
                    {
                        this.optional_params.push(params[i]);
                    }
                }

                this.is_set = false;
                //console.log("set params end");

                self.$nextTick(async function () {

                    if (self.type_save_default)
                    {
                        self.load_name = self.type_save_default
                    };
                    
                    for (var i = 0; i < params.length; i++)
                    {
                        if (params[i].type.type == 'database')
                            self.updateTable(i);
                        if (params[i].type.type == 'textarea_plus' || 
                            params[i].type.type == 'json_schema_editor' || 
                            params[i].type.type == 'mapping' || 
                            params[i].type.type == 'autocomplete_list' || 
                            params[i].type.type == 'object')
                            self.$refs["params_" + i][0].load(params[i].value);
                    }
                });
            },
            add(idx)
            {
                var self = this;

                this.params.push(this.optional_params[idx]);
                this.optional_params.splice(idx, 1);

                self.$nextTick(async function () {
                    if (self.params[self.params.length - 1].type.type == 'database')
                        self.updateTable(self.params.length - 1);
                });
            },
            del(idx)
            {
                var param = this.params[idx];
                // Réinitialiser la valeur à son défaut : sinon un paramètre optionnel
                // décoché conserve la dernière valeur test (ex: modifiée par un script lors
                // d'un run précédent), ce qui n'est pas cohérent avec le fait qu'il soit
                // redevenu "non renseigné" côté UI — un script qui ne (re)set la valeur que
                // si elle est vide/absente ne la mettrait alors plus jamais à jour.
                var default_value = Array.isArray(param.targets) ? param.default_value : param.default;
                if (param.type.type == 'booleen')
                    default_value = (default_value === true || default_value === 'true' || default_value === 1 || default_value === '1');
                else if (param.type.type == 'autocomplete')
                {
                    var value = [];
                    var arr = Array.isArray(default_value) ? default_value : [];
                    for (var j = 0; j < arr.length; j++)
                        value.push({ text: arr[j] });
                    default_value = value;
                }
                else if (param.type.type == 'draggable' || param.type.type == 'draggable_list')
                {
                    var value = [];
                    var arr = Array.isArray(default_value) ? default_value : [];
                    for (var j = 0; j < arr.length; j++)
                        value.push({ value: arr[j] });
                    default_value = value;
                }
                param.value = default_value;

                this.optional_params.push(param);
                this.params.splice(idx, 1);
            },
			async updateTable(idx) {
				var self = this;
				this.$refs["params_" + idx][0].init(self.params[idx].type.table);
			}
		},
		mounted: async function () {
            var self = this;
            
			var user = store.state.user;
            var response = await users.getSelf(true);
			this.client = response.client;

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			if (tables && tables.length > 0) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			var database_tables = null;
			if (
				user.rules != null &&
				user.rules.database == "certaines tables"
			) {
				database_tables = {};

				for (
					var i = 0;
					i < user.rules.database_tables.length;
					i++
				) {
					database_tables[
						user.rules.database_tables[i].name
					] = user.rules.database_tables[i];
				}
			}

			this.tables = [];
			if (tables && tables.length > 0 && database_tables) {
				for (var i = 0; i < tables.length; i++) {
					if (
						tables[i] && !tables[i].hide && database_tables[tables[i].name] &&
						(!database_tables || !database_tables[tables[i].name].hide) &&
						(!database_tables ||
							(database_tables[tables[i].name] &&
								database_tables[tables[i].name].read))
					)
					{
						this.tables.push(tables[i].name);
					}
				}
            }
            
            if (tables && tables.length > 0 && (user.rules == null || user.rules.database == "activé")) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}
		},
	};
</script>

<style scoped>
</style>
